import styled from "styled-components"

import {IconButton as IconButtonBase} from "@irati/ui/src/Button"

interface IconButtonProps {
  previousNav?: boolean
}
export const IconButton = styled(IconButtonBase).attrs({size: 24})<IconButtonProps>`
         position: absolute;
         z-index: 10;
         background: white;
         top: 50%;
         border-radius: 2px;
         padding: ${({theme}) => theme.spacing.one};
         transform: ${({previousNav}) => (previousNav ? "translate3D(-25%,-50%,0)" : "translate3D(25%,-50%,0)")};
         left: ${({previousNav}) => (previousNav ? "0" : "auto")};
         right: ${({previousNav}) => (previousNav ? "auto" : "0")};
         box-shadow: ${({theme}) => theme.shadows.low};
       `
